import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SSIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SS" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#4E8B1D"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Path fill="#E31D1C" stroke="#F7FCFF" d="M16.5 3.5v5h-17v-5h17Z" />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="m0 0 10 6-10 6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="m3.324 7.204-1.01 1.05-.105-1.492L.92 5.968l1.343-.42.22-1.48.93 1.171 1.355-.363-.7 1.387.681 1.339-1.426-.398Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
